// @/components/Can.tsx

import { Tooltip } from "antd";
import { isPermissionSystemEnabled } from "@/lib/utils/permissionDebug";
import { useActionPermission } from "./permissions";
export const AccessControl = ({
  do: action,
  children,
  not: fallback = null,
  withTooltip = false,
}: {
  do: string;
  children: React.ReactNode;
  not?: React.ReactNode;
  withTooltip?: boolean;
}) => {
  const isPermissionSystemEnabledValue: boolean = isPermissionSystemEnabled();
  const permitted = useActionPermission(action);
  return (
    <>
      {isPermissionSystemEnabledValue ? (
        permitted ? (
          children
        ) : withTooltip ? (
          <Tooltip title="You are not authorized to perform this action">{fallback}</Tooltip>
        ) : (
          fallback
        )
      ) : (
        children
      )}
    </>
  );
};
export default AccessControl;
